"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledImage = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledImage = styled_components_1.default.img `
  width: ${({ width, fullWidth }) => (fullWidth ? '100%' : width !== null && width !== void 0 ? width : 'auto')};
  height: ${({ height }) => height !== null && height !== void 0 ? height : 'auto'};
  ${({ customStyles }) => customStyles || {}}
`;
//# sourceMappingURL=styles.js.map